export default function RectCropIcon({ className="", onClick=null }) {
  return (
    <>
      <svg className={className} onClick={onClick} xmlns="http://www.w3.org/2000/svg" id="Capa_1" viewBox="0 0 700 700">
        <path d="M536,594H164c-31.98,0-58-26.02-58-58V164c0-31.98,26.02-58,58-58h372c31.98,0,58,26.02,58,58v372c0,31.98-26.02,58-58,58ZM164,153c-6.06,0-11,4.93-11,11v372c0,6.06,4.93,11,11,11h372c6.06,0,11-4.93,11-11V164c0-6.06-4.93-11-11-11H164Z"/>
      </svg>
    </>
  );
}